import sectionsOperations from "fantastic/lib/sections";
export default id => (dispatch, getState) => {
  const { sections } = getState();
  const data = JSON.parse(
    JSON.stringify(sectionsOperations.byId(id, sections))
  );

  const type =
    data.meta.type.toLowerCase().replace(/^\w/, chr => chr.toUpperCase()) +
    "Entity";

  switch (data.meta.type) {
    case "SECTION": {
      data.contents.forEach(column => {
        delete column.id;
        delete column.meta;
        if (column.items && column.items.length > 0)
          column.items.forEach(item => {
            delete item.id;
            delete item.meta;
            if (
              item.kind &&
              item.kind === "table" &&
              item.rows &&
              item.rows.length > 0
            ) {
              item.rows.forEach(row => {
                if (row.columns && row.columns.length > 0) {
                  row.columns.forEach(cell => {
                    delete cell.id;
                    delete cell.meta;
                    if (cell.items && cell.items.length > 0) {
                      cell.items.forEach(cellItem => {
                        delete cellItem.id;
                        delete cellItem.meta;
                      });
                    }
                  });
                }
              });
            }
          });
      });
      break;
    }
    case "ITEM": {
      delete data.meta;
      delete data.id;
      if (
        data.kind &&
        data.kind === "table" &&
        data.rows &&
        data.rows.length > 0
      ) {
        data.rows.forEach(row => {
          if (row.columns && row.columns.length > 0) {
            row.columns.forEach(cell => {
              delete cell.id;
              delete cell.meta;
              if (cell.items && cell.items.length > 0) {
                cell.items.forEach(cellItem => {
                  delete cellItem.id;
                  delete cellItem.meta;
                });
              }
            });
          }
        });
      }
      break;
    }
  }
  dispatch({ type: "FAVORITE/ID", payload: { data, type } });
};
